module.exports = "<p>\r\n  parametre works!\r\n</p>\r\n"